var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.result)?_c('div',{staticClass:"result"},[_c('h2',[_vm._v("\n    "+_vm._s(_vm.result.title)+"\n  ")]),_vm._v(" "),_c('pre',{domProps:{"innerHTML":_vm._s(_vm.result.value)}})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-097db513","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Result.vue
// module id = 4P/4
// module chunks = 0